import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OuiSelectOption, OuiValidationError } from 'omnium-ui/form-field';

@Component({
  selector: 'app-motivation-operation',
  templateUrl: './motivation-operation.component.html',
  styleUrls: ['./motivation-operation.component.scss'],
})
export class MotivationOperationComponent {
  @Input({ required: true }) control: FormControl<string | null>;
  @Input() options: OuiSelectOption<string>[] = [];
  @Input() errors: OuiValidationError[] = [];
}
